import { RichIcon, RichIconTypes } from '@eika/rich-icon';
import './header-icon.scss';

export const HeaderIcon = () => (
    <div className="pending-process-container__icon">
        <RichIcon type={RichIconTypes.FORELDREKONTROLL_OEKONOMISK_VEILEDER_KUNNSKAP} />
    </div>
);
